import { isPlatformBrowser } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  Inject,
  PLATFORM_ID,
} from '@angular/core';
import { FuseUtilsService } from '@fuse/services/utils';
import { MarketplaceSeoService } from 'app/pages/marketplace/marketplace-seo.service';
import { Observable, tap } from 'rxjs';
import { AutomobiliaService } from '../automobilia.service';

@Component({
  selector: 'app-detail',
  templateUrl: './detail.component.html',
  styleUrls: ['./detail.component.scss'],
})
export class DetailComponent implements AfterViewInit {
  constructor(
    private service: AutomobiliaService,
    private _utilService: FuseUtilsService,
    private _changeDetectorRef: ChangeDetectorRef,
    private seoService: MarketplaceSeoService,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {}

  product: any;
  pagelink = '';

  get product$(): Observable<any> {
    return this.service.product$.pipe(
      tap((product) => {
        this.product = product?.data.attributes;
        this.product.id = product?.data.id;
        this.seoService.setProduct(product);
        // Mark for check
        this._changeDetectorRef.markForCheck();
      }),
    );
  }

  ngAfterViewInit(): void {
    this.service.incremetView().subscribe((product) => {
      this.product.numberViews = product.data.attributes.numberViews;
    });

    if (isPlatformBrowser(this.platformId)) {
      this.pagelink = window.location.href;
    }
  }

  getImageUrl(image, format = 'large') {
    if (format === 'full') {
      return image?.attributes?.url || '';
    }

    if (image?.attributes?.formats[format]?.url) {
      return image?.attributes?.formats[format]?.url;
    }

    return image?.attributes?.url || '';
  }

  validCustomSuffix(item) {
    return ['cc', 'cv', 'km'].includes(item);
  }
}
